/** WebM gravado via MediaRecorder costuma vir sem duração (0:00 / Infinity). */
export function attachWebmAudioDurationFix(
  audio: HTMLAudioElement,
  onDuration?: (seconds: number) => void
): () => void {
  let disposed = false

  const emitIfValid = () => {
    const d = audio.duration
    if (Number.isFinite(d) && d > 0) {
      onDuration?.(d)
      return true
    }
    return false
  }

  const seekForDuration = () => {
    if (disposed || emitIfValid()) return

    const onTimeUpdate = () => {
      audio.removeEventListener('timeupdate', onTimeUpdate)
      const duration = audio.duration
      try {
        audio.currentTime = 0
      } catch {
        /* ignore */
      }
      if (Number.isFinite(duration) && duration > 0) {
        onDuration?.(duration)
      }
    }

    audio.addEventListener('timeupdate', onTimeUpdate)
    try {
      audio.currentTime = Number.MAX_SAFE_INTEGER
    } catch {
      audio.removeEventListener('timeupdate', onTimeUpdate)
    }
  }

  const onLoadedMetadata = () => {
    if (disposed) return
    if (emitIfValid()) return
    seekForDuration()
  }

  const onDurationChange = () => {
    if (disposed) return
    emitIfValid()
  }

  audio.addEventListener('loadedmetadata', onLoadedMetadata)
  audio.addEventListener('durationchange', onDurationChange)

  if (audio.readyState >= 1) {
    onLoadedMetadata()
  }

  return () => {
    disposed = true
    audio.removeEventListener('loadedmetadata', onLoadedMetadata)
    audio.removeEventListener('durationchange', onDurationChange)
  }
}
